import { render, staticRenderFns } from "./RbuVolume.vue?vue&type=template&id=27ca39c0"
import script from "./RbuVolume.vue?vue&type=script&lang=js"
export * from "./RbuVolume.vue?vue&type=script&lang=js"
import style0 from "./RbuVolume.vue?vue&type=style&index=0&id=27ca39c0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports